import React, { Component } from "react"
import { TweenLite, Power1 } from "gsap"
import Img from "gatsby-image"
import { css } from "@emotion/core"
import styled from "@emotion/styled"
import { graphql } from "gatsby"
import SEO from "../components/seo"
import Header from "../components/header/header"
import {
  HomeWrapper,
  Slide,
  NextButton,
  SlideText,
  ProgressContainer,
  ProgressBarWrapper,
  ProgressBar,
  ProgressCounter,
  ProgressCounterText,
} from "../styled-components/index-styles"
const debounce = require("lodash/debounce")

const Reveal = styled.div`
  position: fixed;
  box-sizing: border-box;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  padding: 4rem;
  background: #000c;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 99;
  transition: all 0.4s ease-in-out;
  opacity: 0;
  pointer-events: none;

  &.open {
    opacity: 1;
    pointer-events: all;
  }

  div {
    width: 100%;
  }

  button {
    position: absolute;
    right: 2rem;
    top: 2rem;
    background: none;
    border: none;
    line-height: 1ch;
    font-size: 2rem;
    transform: rotate(45deg);
    transition: all 0.4s ease-in-out;
    color: #fefefe;

    :hover {
      cursor: pointer;
      transform: rotate(0);
    }
  }

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`

class ReviewsPage extends Component {
  constructor(props) {
    super(props)
    this.state = { currentSlide: 0, startX: 0, endX: 0 }
  }

  changeSlide = () => {
    const slideIndex = this.state.currentSlide
    const currentSlide = document.querySelector(`[data-slide="${slideIndex}"]`)
    const nextSlide = document.querySelector(`[data-slide="${slideIndex + 1}"]`)
    const prevSlide = document.querySelector(`[data-slide="${slideIndex - 1}"]`)
    if (slideIndex < 9) {
      this.nextSlide(currentSlide, nextSlide)
    } else if (slideIndex > 0) {
      this.prevSlide(currentSlide, prevSlide)
    }
  }

  scrollSlide = delta => {
    const slideIndex = this.state.currentSlide
    const currentSlide = document.querySelector(`[data-slide="${slideIndex}"]`)
    const nextSlide = document.querySelector(`[data-slide="${slideIndex + 1}"]`)
    const prevSlide = document.querySelector(`[data-slide="${slideIndex - 1}"]`)
    if (slideIndex < 9 && delta > 0) {
      this.nextSlide(currentSlide, nextSlide)
    } else if (slideIndex > 0 && delta < 0) {
      this.prevSlide(currentSlide, prevSlide)
    }
  }

  nextSlide = (currentSlide, nextSlide) => {
    TweenLite.to(currentSlide, 1, {
      x: "-100vw",
      opacity: "0",
      onComplete: () => {
        TweenLite.to(currentSlide.querySelector("video, img"), 1, {
          ease: Power1.easeInOut,
          css: { scale: "1.1" },
        })
      },
    })
    TweenLite.to(nextSlide, 1, {
      x: "0",
      opacity: "1",
      display: "flex",
    })
    this.finishSlide(1, currentSlide, nextSlide)
  }

  prevSlide = (currentSlide, prevSlide) => {
    TweenLite.to(currentSlide, 1, {
      x: "100vw",
      opacity: "0",
      onComplete: () => {
        TweenLite.to(currentSlide.querySelector("video, img"), 1, {
          ease: Power1.easeInOut,
          css: { scale: "1.1" },
        })
      },
    })
    TweenLite.to(prevSlide, 1, {
      x: "0",
      opacity: "1",
      display: "flex",
    })
    this.finishSlide(-1, currentSlide, prevSlide)
  }

  finishSlide = (setState, currentSlide, newSlide) => {
    if (currentSlide.querySelector("video")) {
      currentSlide.querySelector("video").pause()
    }
    if (newSlide.querySelector("video")) {
      newSlide.querySelector("video").play()
    }
    currentSlide.classList.remove("active")
    newSlide.classList.add("active")
    setTimeout(() => {
      TweenLite.to(newSlide.querySelector("video, img"), 0.6, {
        ease: Power1.easeInOut,
        css: { scale: "1" },
      })
    }, 300)
    setState > 0
      ? this.setState(state => ({
          currentSlide: state.currentSlide + 1,
        }))
      : this.setState(state => ({
          currentSlide: state.currentSlide - 1,
        }))
  }

  componentDidUpdate() {
    TweenLite.to(".progress-bar", 1, {
      width: `${(this.state.currentSlide + 1) * 20}px`,
    })
    if (this.state.currentSlide === 9) {
      document.querySelector(".next-button").disabled = true
    } else {
      document.querySelector(".next-button").disabled = false
    }
  }

  componentDidMount() {
    const slides = document.querySelectorAll(".slide")
    slides.forEach((slide, index) => {
      if (index > 0) {
        TweenLite.set(slide, {
          x: "100vw",
          opacity: "0",
        })
      }
    })
    document.querySelector(".home").addEventListener(
      "wheel",
      debounce(
        e => {
          this.scrollSlide(e.deltaY)
        },
        100,
        {
          leading: true,
          trailing: false,
        }
      ),
      { passive: true }
    )

    document.querySelector(".home").addEventListener(
      "touchstart",
      debounce(
        e => {
          this.setState({ startX: e.touches[0].clientX })
        },
        100,
        {
          leading: true,
          trailing: false,
        }
      )
    )
    document.querySelector(".home").addEventListener(
      "touchmove",
      debounce(
        e => {
          this.setState({ endX: e.touches[0].clientX })
          if (this.state.startX < this.state.endX) {
            this.scrollSlide(-1)
          } else {
            this.scrollSlide(1)
          }
        },
        100,
        {
          leading: true,
          trailing: false,
        }
      )
    )
  }

  openReveal = e => {
    const src = e.target.parentNode.dataset.iframe
    const reveal = document.querySelector(".reveal")
    const iframe = document.createElement("div")
    iframe.classList.add("iframe-wrapper")
    iframe.style.maxWidth = "1440px"
    iframe.innerHTML = src
    reveal.classList.add("open")
    reveal.appendChild(iframe)
  }

  closeReveal = () => {
    const reveal = document.querySelector(".reveal")
    const iframe = reveal.querySelector(".iframe-wrapper")
    reveal.removeChild(iframe)
    reveal.classList.remove("open")
  }

  render() {
    return (
      <>
        <SEO title="Home" />
        <Header />
        <Reveal className="reveal">
          <button onClick={this.closeReveal}>&times;</button>
        </Reveal>
        <HomeWrapper className="home">
          <Slide
            data-slide="0"
            data-iframe='<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/282575121?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
            className="slide active"
          >
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Berger Lagnese
            </p>
            <SlideText className="slide__text">
              we have seen dramatic improvements in performance since moving our
              website and SEO to the folks at nextlevel
            </SlideText>
            <button
              onClick={this.openReveal}
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            >
              Watch our video
            </button>
            <Img fixed={this.props.data.lagnese.childImageSharp.fixed} />
          </Slide>
          <Slide data-slide="1" className="slide">
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Blume, Forte, Fried, Zerres & Molinari
            </p>
            <SlideText className="slide__text">
              we have been with nextlevel for years and the improvement we’ve
              seen in the results of our advertising has been nothing short of
              amazing
            </SlideText>
            <button
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                opacity: 0;
                pointer-events: none;

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            ></button>
            <Img fixed={this.props.data.blume.childImageSharp.fixed} />
          </Slide>
          <Slide
            data-slide="2"
            data-iframe='<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/282575454?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
            className="slide"
          >
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Purchase, George & Murphey
            </p>
            <SlideText className="slide__text">
              they provide expert advice, great results and a very high level of
              customer service
            </SlideText>
            <button
              onClick={this.openReveal}
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            >
              Watch our video
            </button>
            <Img fixed={this.props.data.purchase.childImageSharp.fixed} />
          </Slide>
          <Slide
            data-slide="3"
            data-iframe='<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/162847764?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
            className="slide"
          >
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Proner & Proner
            </p>
            <SlideText className="slide__text">
              I actually left nextlevel at one point for a cheaper alternative
              but returned quickly after learning that not everybody can produce
              the results they say they can
            </SlideText>
            <button
              onClick={this.openReveal}
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            >
              Watch our video
            </button>
            <Img fixed={this.props.data.proner.childImageSharp.fixed} />
          </Slide>
          <Slide
            data-slide="4"
            data-iframe='<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/182107122?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
            className="slide"
          >
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Andres & Berger
            </p>
            <SlideText className="slide__text">
              everybody says they love the website, traffic is up, leads are up
              and their service is excellent
            </SlideText>
            <button
              onClick={this.openReveal}
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            >
              Watch our video
            </button>
            <Img fixed={this.props.data.berger.childImageSharp.fixed} />
          </Slide>
          <Slide data-slide="5" className="slide">
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Michele Finizio Law
            </p>
            <SlideText className="slide__text">
              since hiring nextlevel my business has tripled - not sure anything
              else I say will matter as much as that
            </SlideText>
            <button
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                opacity: 0;
                pointer-events: none;

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            ></button>
            <Img fixed={this.props.data.finizio.childImageSharp.fixed} />
          </Slide>
          <Slide data-slide="6" className="slide">
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Lawlor, White & Murphey
            </p>
            <SlideText className="slide__text">
              nextlevel did a fantastic job on our videos and new website, we
              receive compliments regularly
            </SlideText>
            <button
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                opacity: 0;
                pointer-events: none;

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            ></button>
            <Img fixed={this.props.data.lawlor.childImageSharp.fixed} />
          </Slide>
          <Slide
            data-slide="7"
            data-iframe='<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/129118971?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
            className="slide"
          >
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Lombardi & Lombardi
            </p>
            <SlideText className="slide__text">
              things improved very quickly after hiring nextlevel - leads coming
              in from the web have never been higher!
            </SlideText>
            <button
              onClick={this.openReveal}
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            >
              Watch our video
            </button>
            <Img fixed={this.props.data.lombardi.childImageSharp.fixed} />
          </Slide>
          <Slide
            data-slide="8"
            data-iframe='<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/282575304?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
            className="slide"
          >
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Goodrich & Geist
            </p>
            <SlideText className="slide__text">
              we continue to increase our investment with nextlevel because the
              increase in business has been so great!
            </SlideText>
            <button
              onClick={this.openReveal}
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            >
              Watch our video
            </button>
            <Img fixed={this.props.data.goodrich.childImageSharp.fixed} />
          </Slide>
          <Slide
            data-slide="9"
            data-iframe='<div style="padding:56.25% 0 0 0;position:relative;"><iframe src="https://player.vimeo.com/video/128389133?title=0&byline=0&portrait=0" style="position:absolute;top:0;left:0;width:100%;height:100%;" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe></div><script src="https://player.vimeo.com/api/player.js"></script>'
            className="slide"
          >
            <p
              css={css`
                font-family: "Montserrat", sans-serif;
                font-weight: 700;
                font-size: 12px;
                letter-spacing: 3px;
                color: #fefefe;
                text-transform: uppercase;
                z-index: 2 !important;
              `}
            >
              Bramnick Law
            </p>
            <SlideText className="slide__text">
              when you find a company you can rely on and that you like and
              trust - you hire them.
            </SlideText>
            <button
              onClick={this.openReveal}
              css={css`
                background-color: #1d5f83;
                font-family: "Montserrat", sans-serif;
                transform: scale(1, 0.9);
                font-weight: 700;
                font-size: 12px;
                text-transform: uppercase;
                text-align: center;
                color: #fefefe;
                z-index: 50;
                padding: 1rem 3rem;
                text-decoration: none;
                letter-spacing: 3px;
                transition: all 0.4s ease-in-out;
                margin-top: 4rem;
                border: none;

                &:hover {
                  cursor: pointer;
                }

                &::after {
                  content: "";
                  display: block;
                  width: 10rem;
                  height: 2px;
                  background-color: #fff;
                  position: absolute;
                  right: 90%;
                  top: 50%;
                }

                &:hover {
                  background-color: #143c52;
                }
              `}
              className="button primary"
              to="/"
            >
              Watch our video
            </button>
            <Img fixed={this.props.data.bramnick.childImageSharp.fixed} />
          </Slide>
          <NextButton onClick={this.changeSlide} className="next-button">
            Next
          </NextButton>
          <ProgressContainer>
            <ProgressBarWrapper>
              <ProgressBar className="progress-bar" />
            </ProgressBarWrapper>
          </ProgressContainer>
          <ProgressCounter>
            <ProgressCounterText>
              {this.state.currentSlide === 9
                ? this.state.currentSlide + 1
                : this.state.currentSlide + 1}
            </ProgressCounterText>
            <ProgressCounterText>10</ProgressCounterText>
          </ProgressCounter>
        </HomeWrapper>
      </>
    )
  }
}

export const query = graphql`
  {
    berger: file(relativePath: { eq: "berger-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    blume: file(relativePath: { eq: "blume-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    bramnick: file(relativePath: { eq: "bramnick-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    finizio: file(relativePath: { eq: "finizio-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    goodrich: file(relativePath: { eq: "goodrich-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    lagnese: file(relativePath: { eq: "lagnese-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    lawlor: file(relativePath: { eq: "lawlor-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    lombardi: file(relativePath: { eq: "lombardi-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    proner: file(relativePath: { eq: "proner-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
    purchase: file(relativePath: { eq: "purchase-test-bg.jpg" }) {
      childImageSharp {
        fixed(width: 1920, quality: 100) {
          ...GatsbyImageSharpFixed_withWebp
        }
      }
    }
  }
`

export default ReviewsPage
